import { render } from "./manage-profile.vue?vue&type=template&id=c9bf5854&scoped=true"
import script from "./manage-profile.vue?vue&type=script&lang=js"
export * from "./manage-profile.vue?vue&type=script&lang=js"

import "./manage-profile.vue?vue&type=style&index=0&id=c9bf5854&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9bf5854"]])

export default __exports__